import { createCommunityRemix } from 'lib/analytics';
import { createRemixAndOpen } from 'lib/remixes';
import { VoidCallback } from 'types/callbacks';
import { CommunityShotItem } from 'types/community';
import RemixModalContainer, { RemixModalActions } from './RemixModalContainer';
import { useState } from 'react';
import TeamSelection from './TeamSelection';
import { TeamResponse } from 'lib/teams';

type Props = {
  display: boolean;
  onClose: VoidCallback;
  onCreate?: VoidCallback;
  shotItem: CommunityShotItem;
  teams: TeamResponse[];
};

export default function AlreadyRemixedModal({
  display,
  onClose,
  onCreate,
  shotItem,
  teams,
}: Props) {
  const [selectedTeam, selectTeam] = useState(
    teams !== undefined && teams.length > 0 ? teams[0] : undefined
  );
  function onRemixAgain() {
    const teamId = selectedTeam?.ownerId;
    if (teamId) {
      createRemixAndOpen(teamId, shotItem.revisionId, shotItem.title).then(
        (remix) => {
          onCreate && onCreate();
          if (remix) {
            createCommunityRemix(
              shotItem.communityPostId,
              shotItem.fileId,
              shotItem.title,
              shotItem.isRemix,
              remix.fileId,
              'remix_again'
            );
          }
        }
      );
      onClose();
    }
  }

  return (
    <RemixModalContainer display={display} onClose={onClose}>
      <h1>Remix</h1>
      <p>
        It looks like you already remixed this file.
        <br />
        Do you want to create another copy?
      </p>
      <TeamSelection
        teams={teams}
        selectTeam={selectTeam}
        selectedTeam={selectedTeam}
      />
      <RemixModalActions>
        <button onClick={onRemixAgain}>Remix again</button>
      </RemixModalActions>
    </RemixModalContainer>
  );
}
